import React, {useState,useCallback} from "react";
import useCategorias from '../../../Hooks/useCategorias';
import HeaderAdmin from '../../../Components/HeaderAdmin';
import styled from "styled-components";
import {Close, Save} from '@material-ui/icons';
import { Checkbox, FormControlLabel, IconButton,Tooltip,Fab } from '@material-ui/core';
import Input from '../../../Components/Input';
import ComboBox from '../../../Components/ComboBox';
import BlueButton from "../../../Components/BlueButton";
import realtimeDB, { storage } from "../../../Utils/api";
import { useAllItems } from "../../../Hooks/useItems";
import Alert from "../../../Components/Alert";
import { useHistory } from "react-router-dom";
import {useDropzone} from 'react-dropzone'
import uploadImage from "../../../Utils/uploadImage";

const ContainerDropZone=styled.div`
margin:10px;
border:3px dashed;`;

const TextoDropZone=styled.p`
margin:0px;
padding:5% 10%;
text-align:center;`;

const ContainerImage=styled.div`
position:relative;
display:grid;`;

const ImgPreview=styled.img`
margin:15px auto;
height:25vh;`;

const StyleFAB=
{
    position: "absolute",
    bottom: 0,
    right: 0,
    margin: "20px",
    background:"#0088FF"
}

const Row=({children})=>
{
    const Items=children.length;
    const Porcentaje = 100 / Items;
    var Largo="";
    Array.from({length:Items}).map(() => Largo+=`${Porcentaje}% `);
    
    return <div style={{display:"grid",gridTemplateColumns:Largo,alignItems:"center"}}>
        {children}
    </div>
}


const NewItem = () =>
{
    const [Nombre, setNombre] = useState("");
    const [Descripcion, setDescripcion] = useState("");
    const [Precio, setPrecio] = useState("");
    const [DescripcionCorta, setDescripcionCorta] = useState("");
    const [Categoria, setCategoria] = useState(undefined);
    const [Indice, setIndice] = useState("");
    const [Imagen, setImagen] = useState(undefined);
    const [VariablesSimultaneas, setVariablesSimultaneas] = useState(0)
    const [esNovedad,setesNovedad]=useState(0);

    const [Error, setError] = useState(undefined);

    const Items=useAllItems();
    const Categorias=useCategorias();

    const History=useHistory();

    const comprobarVacio=()=>
    {
        const NombreVacio=Nombre === "";
        const PrecioVacio=Precio==="";
        const IndiceVacio=Indice==="";

        if(NombreVacio || PrecioVacio || IndiceVacio)
        {
            return true;
        }
        return false;
    }

    const addItem=async()=>
    {
        const ID=Date.now();
        const finalCategoria=(Categoria=== "" || Categoria===undefined) ? Categorias[0].data.Nombre : Categoria;
        const finalVariablesMaximas=Number(VariablesSimultaneas)<0 ? 0 : Number(VariablesSimultaneas);

        const Existe=Items.filter(item => item.Nombre===Nombre).length === 0 ? false : true;
        
        const InputsVacios=comprobarVacio();

        if(InputsVacios)
        {
            setError("Comprobar campos");
        }
        else
        {
            if(!Existe)
            {
                const ItemRef= realtimeDB.ref(`/Menu/CategoriasDOS/${finalCategoria}/Items`).child(ID);

                const DefaultImage="https://baumlanus.s3.sa-east-1.amazonaws.com/Imagen_no_disponible_41b46cb63f.jpg";     

                var ProductoJSON=
                {
                    Nombre,
                    Estado:true,
                    Precio: Number(Precio),
                    Descripcion,
                    DescripcionCorta,
                    Indice:Number(Indice),
                    Categoria:finalCategoria,
                    VariablesSimultaneas:finalVariablesMaximas,
                    Imagen:DefaultImage,
                }      

                if(Imagen)
                {
                   const ImagePath=await uploadImage(Imagen);
                   ProductoJSON.Imagen=ImagePath;
                }      

                await ItemRef.set(ProductoJSON);
                 
                if(esNovedad)
                {
                    const novedadRef= realtimeDB.ref(`/Menu/CategoriasDOS/Novedades/Items`).child(ID);
                    await novedadRef.set(ProductoJSON);
                }      

                History.push("/admin/menu");
            }
            else
            {
             setError(`${Nombre} ya existe`);
            }
        }
    }

    const DropZone= () => 
    {
        const UploadImage=()=>
        {
            const {getRootProps, getInputProps,isDragActive} = useDropzone({maxFiles:1,accept:"image/*", onDrop: imagenes=>
            {
                setImagen(imagenes.map( imagen => Object.assign(imagen,{preview: URL.createObjectURL(imagen)}))[0])
            }});

            return <section className="container">
            <ContainerDropZone {...getRootProps({className: 'dropzone'})}>
              <input {...getInputProps()} />
              {isDragActive ? <TextoDropZone>Suelta la imagen</TextoDropZone> : <TextoDropZone>Arrastrá o clickeá</TextoDropZone>}
            </ContainerDropZone>
          </section>
        }

        const PreviewImage=()=>
        {
            const DeleteImage = () => setImagen(undefined);

            return <ContainerImage>
                <ImgPreview src={Imagen.preview}/>
                <Tooltip title="Remover imagen">
                    <IconButton onClick={DeleteImage} style={{position:"absolute",top:0,right:0}} >
                        <Close/>
                    </IconButton>
                </Tooltip>
            </ContainerImage>
        }

        if(!Imagen)
        {
            return <UploadImage/>
        }

        return <PreviewImage/>
    }

    return <div>
        <HeaderAdmin title={"Menú"}/>
        <DropZone/>
        <div className='container'>
            <Row>
                <Input label="Nombre" value={Nombre} changeValue={setNombre} styleCSS={{padding:"10px"}}/>
                <ComboBox label="Categoria" options={Categorias} value={Categoria} changeValue={setCategoria} />
            </Row>
            <Input label="Descripcion" value={Descripcion} changeValue={setDescripcion} styleCSS={{padding:"10px"}}/>
            <Row>
                <Input label="Precio" type="number" value={Precio} changeValue={setPrecio} styleCSS={{padding:"10px"}}/>
                <Input label="Descripcion corta" value={DescripcionCorta} changeValue={setDescripcionCorta} styleCSS={{padding:"10px"}}/>
            </Row>
            <Row>
                <Input label="Indice" type="number" value={Indice} changeValue={setIndice} styleCSS={{padding:"10px"}}/>
                <Input label="Variables simultaneas" type="number" value={VariablesSimultaneas} changeValue={setVariablesSimultaneas} styleCSS={{padding:"10px"}}/>
            </Row>
            <Row>
                <FormControlLabel color="blue" style={{margin:"5px"}} control={<Checkbox color="#0088FF" checked={esNovedad} onChange={e => setesNovedad(e.target.checked)} />} label="Novedad" />
            </Row>
            <Tooltip title="Guardar">
                <Fab style={StyleFAB} color="primary" onClick={addItem}>
                    <Save/>
                </Fab>
            </Tooltip>  
        </div>
        <Alert mensaje={Error} close={() => setError(undefined)}/>
    </div>

}

export default NewItem

